/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-alerts-page-grid .ui-grid-cell[data-property=component] .ui-grid-cell-content{height:100%;display:flex;align-items:center}.ui-alerts-page-grid .ui-grid-cell[data-property=component] .ui-grid-cell-content mat-icon{margin-right:5px;min-width:24px}.ui-alerts-page-grid .alert-unread{font-weight:700}.ui-alerts-page-grid .ui-grid-cell.ui-grid-feature-cell.ui-grid-action-cell{min-width:100px}"];
export { styles as styles };
